import React, { useState } from 'react';
import useGlobalElementsService from '../../Hooks/useGlobalElementsService';
import { useMount } from 'react-use';
import { ApiImageContainer } from '@ibe/api';
import { Media } from 'reactstrap';

const CustomizableHeader = ({
  contentRenderer
}: {
  contentRenderer?: () => React.ReactElement;
}) => {
  const cmsGlobalElementsService = useGlobalElementsService();
  const [logo, setLogo] = useState<ApiImageContainer>();
  const [headerHref, setHeaderHref] = useState<string | undefined>();

  useMount(() => {
    cmsGlobalElementsService.fetchGlobalElements().then(ge => {
      setLogo(ge.headerImage);
      setHeaderHref(ge.headerHref);
    });
  });

  const logoImage = logo?.small?.url ? (
    <Media
      src={logo.small?.url}
      alt={logo.imageAlt ?? 'header-logo'}
      className="customizable-header__logo"
    />
  ) : null;

  let wrappedLogo = null;

  if (logoImage) {
    wrappedLogo = headerHref ? (
      <a
        href={headerHref}
        className="customizable-header__logo-link"
        target="_blank"
        rel="noopener noreferrer"
      >
        {logoImage}
      </a>
    ) : (
      <div className="customizable-header__logo-wrapper">{logoImage}</div>
    );
  }

  return (
    <div
      className={`customizable-header align-items-center justify-content-${
        logoImage ? 'between' : 'end'
      }`}
    >
      {wrappedLogo}
      {contentRenderer?.()}
    </div>
  );
};

export default CustomizableHeader;
